import { ThemeEvents } from '@theme/events';
import { DialogComponent } from '@theme/dialog'
import {Component} from '@theme/component'
const currentDate = new Date();
function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
function checkDateValidity(date) {
  // Create a Date object from the input
  const inputDate = new Date(date);
  
  // Create a fixed reference date (January 1, 2023)
  const referenceDate = new Date("2023-01-01T00:00:00Z");
  
  // Calculate the absolute difference between the days of the month
  const dayDifference = Math.abs(inputDate.getDate() - referenceDate.getDate());
  
  // Check if the difference is divisible by 5
  return dayDifference % 5 === 0;
}
function updateVariantStatuses(variants, selects, hideUnavailable = false) {
  selects.forEach((currentSelect, index) => {
    // 跳过第一个选择框
    if (index === 0) return;

    const options = [...currentSelect.querySelectorAll("option")];
    const previousValue = selects[index - 1].querySelector(":checked").value;
    
    // 获取可用的下一个选项值
    const availableNextOptions = variants
      .filter(variant => variant.available && variant[`option${index}`] === previousValue)
      .map(variant => variant[`option${index + 1}`]);
    
    // 获取所有可能的下一个选项值（包括不可用的）
    const allNextOptions = variants
      .filter(variant => variant[`option${index}`] === previousValue)
      .map(variant => variant[`option${index + 1}`]);

    options.forEach(option => {
      const optionValue = option.getAttribute('value');
      
      // 重置选项状态
      option.classList.remove("unavailable", "non-existent");
      option.removeAttribute("disabled");
      option.removeAttribute("hidden");
      option.innerText = optionValue;

      if (allNextOptions.includes(optionValue)) {
        if (!availableNextOptions.includes(optionValue)) {
          // 选项存在但不可用
          option.innerText = window.variantStrings.unavailable_with_option.replace("[value]", optionValue);
          option.classList.add('unavailable');
          
          if (hideUnavailable) {
            option.setAttribute("disabled", '');
            option.setAttribute("hidden", '');
          }
        }
      } else {
        // 选项不存在
        option.innerText = window.variantStrings.unavailable_with_option.replace('[value]', optionValue);
        option.classList.add("non-existent");
        option.setAttribute("disabled", '');
        option.setAttribute("hidden", '');
      }
    });
  });
}
function debounce(func, wait) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), wait);
  };
}
function formatMoney(amount, format, removeTrailingZeros = false) {
  // 处理字符串类型的金额（移除可能存在的点号）
  if (typeof amount === "string") {
    amount = amount.replace('.', '');
  }
  
  let formattedValue = '';
  const formatPattern = /\{\{\s*(\w+)\s*\}\}/;
  
  /**
   * 格式化金额的核心函数
   * @param {number} value - 要格式化的金额（以分为单位）
   * @param {number} decimals - 小数位数
   * @param {string} thousandsSeparator - 千位分隔符
   * @param {string} decimalSeparator - 小数分隔符
   * @returns {string} 格式化后的金额字符串
   */
  function formatCurrency(value, decimals = 2, thousandsSeparator = ',', decimalSeparator = '.') {
    // 验证输入
    if (isNaN(value) || value == null) {
      return '0';
    }
    
    // 转换为元并保留指定小数位
    const yuanValue = (value / 100).toFixed(decimals);
    const parts = yuanValue.split('.');
    
    // 添加千位分隔符
    const integerPart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandsSeparator}`);
    
    // 处理小数部分
    let decimalPart = parts[1] ? decimalSeparator + parts[1] : '';
    
    // 如果需要移除尾随的零
    if (removeTrailingZeros && decimalPart === decimalSeparator + '00') {
      decimalPart = '';
    }
    
    return integerPart + decimalPart;
  }
  
  // 根据格式模板中的占位符类型进行格式化
  const formatType = format.match(formatPattern)[1];
  
  switch (formatType) {
    case "amount":
      formattedValue = formatCurrency(amount, 2);
      break;
    case "amount_no_decimals":
      formattedValue = formatCurrency(amount, 0);
      break;
    case "amount_with_comma_separator":
      formattedValue = formatCurrency(amount, 2, '.', ',');
      break;
    case "amount_no_decimals_with_comma_separator":
      formattedValue = formatCurrency(amount, 0, '.', ',');
      break;
    default:
      formattedValue = '0';
  }
  
  // 替换模板中的占位符
  return format.replace(formatPattern, formattedValue);
}

class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll('.quantity-gift');
    this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.mainProduct = this.dataset.mainProduct;
    this.cartItems = document.querySelector("cart-drawer-items");
    this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    
    this.initUnlock();
    
    if (this.saveLocalStorage) {
      this.storeLocalStorageData();
    }
  }

  storeLocalStorageData() {
    this.gifts.forEach(gift => {
      updateGiftGoalInStorage({
        'giftHandle': gift.dataset.handle,
        'giftVariantId': gift.dataset.product,
        'unlockType': "product_quantity",
        'unlockRequirement': gift.dataset.quantity,
        'unlockTarget': this.mainProduct
      });
    });
  }

  initUnlock() {
    let quantity = 1;
    const cartItems = this.mainProduct ? 
      document.querySelectorAll(".cart-item--product-" + this.mainProduct) : 
      null;

    // 从购物车获取数量
    if (cartItems && cartItems.length) {
      quantity = 0;
      for (let i = 0; i < cartItems.length; i++) {
        quantity += parseInt(cartItems[i].dataset.quantity);
      }
    } 
    // 从数量选择器获取数量
    else if (this.quantityBreaks) {
      quantity = parseInt(this.quantityBreaks.selectedQuantity);
    } 
    // 从输入框获取数量
    else if (this.quantitySelector) {
      const quantityInput = this.quantitySelector.querySelector("input[name=\"quantity\"]");
      quantity = parseInt(quantityInput.value);
    }

    this.unlockGifts(quantity, true);
  }

  unlockGifts(quantity, shouldUpdateCart = false) {
    this.unlockedItems = [];
    
    this.gifts.forEach(gift => {
      const giftRequirement = parseInt(gift.dataset.quantity);
      
      if (giftRequirement <= quantity) {
        // 解锁礼物
        gift.classList.add("quantity-gift--unlocked");
        gift.dataset.unlocked = 'true';
        
        const cartItem = document.querySelector('.cart-item--product-' + gift.dataset.handle);
        
        // 如果礼物有产品ID且不在购物车中，添加到解锁列表
        if (gift.dataset.product && !cartItem) {
          this.unlockedItems.unshift(gift.dataset.product);
        }
      } else {
        // 锁定礼物
        gift.classList.remove("quantity-gift--unlocked");
        gift.dataset.unlocked = "false";
      }
    });
    
    // 如果需要更新购物车
    if (this.mainProduct && shouldUpdateCart) {
      this.addRemoveProducts();
    }
  }

  addRemoveProducts() {
    if (!this.mainProduct) {
      return;
    }
    
    const mainProductItems = document.querySelectorAll('.cart-item--product-' + this.mainProduct);
    
    this.gifts.forEach(gift => {
      if (mainProductItems.length) {
        if (gift.dataset.unlocked === "true" && gift.dataset.product) {
          this.addToCart(gift);
        } else {
          this.removeFromCart(gift);
        }
      } else {
        // 如果主产品不在购物车中，移除所有礼物
        this.removeFromCart(gift);
      }
    });
  }

  addToCart(gift) {
    const cartItem = document.querySelector(".cart-item--product-" + gift.dataset.handle);
    
    // 如果礼物已经在购物车中，不再添加
    if (cartItem) {
      return;
    }
    
    const productForm = gift.querySelector("product-form");
    
    // 如果有产品表单，提交表单添加到购物车
    if (productForm && productForm.handleSubmit) {
      productForm.handleSubmit();
    }
  }

  removeFromCart(gift) {
    const cartItem = document.querySelector(".cart-item--product-" + gift.dataset.handle);
    
    // 如果礼物不在购物车中或没有购物车项目，直接返回
    if (!cartItem || !this.cartItems) {
      return;
    }
    
    // 从购物车中移除礼物（设置数量为0）
    this.cartItems.updateQuantity(cartItem.dataset.index, 0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super();
    this.offerIndex = this.dataset.offer;
    this.upsells = this.querySelectorAll(".quantity-break__upsell");
    this.boundToggleHandler = this.handleToggle.bind(this);
    
    // 为可切换的upsell添加点击事件
    this.upsells.forEach(upsell => {
      if (upsell.dataset.toggle === "true") {
        upsell.addEventListener("click", this.boundToggleHandler);
      }
    });
    
    this.initUnlock();
    
    if (this.saveLocalStorage) {
      this.storeLocalStorageData();
    }
  }

  storeLocalStorageData() {
    if (!this.upsells) {
      return;
    }
    
    this.upsells.forEach(upsell => {
      // 只处理礼物类型的upsell
      if (upsell.dataset.type !== "gift") {
        return;
      }
      
      updateGiftGoalInStorage({
        'giftHandle': upsell.dataset.handle,
        'giftVariantId': upsell.dataset.product,
        'unlockType': "product_quantity",
        'unlockRequirement': upsell.dataset.minQuantity,
        'unlockTarget': this.dataset.mainProduct
      });
    });
  }

  disconnectedCallback() {
    // 清理事件监听器
    this.upsells.forEach(upsell => {
      if (upsell.dataset.toggle === 'true') {
        upsell.removeEventListener("click", this.boundToggleHandler);
      }
    });
  }

  unlockGifts(quantity, shouldUpdateCart = false) {
    this.unlockedItems = [];
    
    if (!this.upsells) {
      return;
    }
    
    this.upsells.forEach(upsell => {
      const minQuantity = parseInt(upsell.dataset.minQuantity || 0);
      const isUnlocked = quantity >= minQuantity;
      const isSelected = upsell.dataset.selected === "true";
      const shouldBeActive = isUnlocked && isSelected;
      
      // 更新upsell状态
      upsell.dataset.unlocked = shouldBeActive.toString();
      upsell.classList.toggle('quantity-gift--unlocked', shouldBeActive);
      
      const cartItem = document.querySelector(".cart-item--product-" + upsell.dataset.handle);
      
      // 如果upsell应该激活且有产品ID且不在购物车中
      if (shouldBeActive && upsell.dataset.product && !cartItem) {
        const isToggleable = upsell.dataset.toggle === "true";
        const isCurrentlySelected = upsell.dataset.selected === "true";
        
        // 如果是不可切换的，或者可切换且当前选中的，添加到解锁列表
        if (!isToggleable || (isToggleable && isCurrentlySelected)) {
          this.unlockedItems.unshift(upsell.dataset.product);
        }
      }
    });
    
    // 如果需要更新购物车且是最后一个offer
    if (this.mainProduct && shouldUpdateCart) {
      if (this.dataset.lastOffer === this.dataset.offer) {
        this.addRemoveProducts();
      }
    }
  }

  addRemoveProducts() {
    if (!this.mainProduct) {
      return;
    }
    
    const mainProductItems = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    const itemsToAdd = [];
    const itemsToRemove = [];
    
    this.upsells.forEach(upsell => {
      const cartItem = document.querySelector(".cart-item--product-" + upsell.dataset.handle);
      const isUnlocked = upsell.dataset.unlocked === "true";
      
      if (mainProductItems.length) {
        // 主产品在购物车中
        if (isUnlocked && !cartItem) {
          itemsToAdd.push(upsell);
        } else if (!isUnlocked && cartItem) {
          itemsToRemove.push(upsell);
        }
      } else if (cartItem) {
        // 主产品不在购物车中，但upsell在购物车中
        itemsToRemove.push(upsell);
      }
    });
    
    // 优先移除不应该在购物车中的项目
    if (itemsToRemove.length) {
      this.removeFromCart(itemsToRemove[0]);
    } 
    // 然后添加应该加入购物车的项目
    else if (itemsToAdd.length) {
      this.addToCart(itemsToAdd[0]);
    }
  }

  handleToggle(event) {

    const targetUpsell = event.currentTarget;
    const wasSelected = targetUpsell.dataset.selected === 'true';
    const nowSelected = !wasSelected;
    // 切换选中状态
    targetUpsell.dataset.selected = nowSelected.toString();
    
    // 同步其他offer中的相同upsell
    this.syncUpsellAcrossOffers(targetUpsell.dataset.handle, nowSelected);
    
    // 同步购物车状态
    this.syncCart(targetUpsell.dataset.handle, nowSelected, targetUpsell);

  }

  syncUpsellAcrossOffers(upsellHandle, shouldBeSelected) {
    const allOfferElements = document.querySelectorAll("quantity-break-upsells");
    
    allOfferElements.forEach(offerElement => {
      offerElement.querySelectorAll(`.quantity-break__upsell[data-handle="${upsellHandle}"]`)
        .forEach(upsellElement => {
          upsellElement.dataset.selected = shouldBeSelected.toString();
        });
    });
  }

  syncCart(upsellHandle, shouldBeInCart, upsellElement) {
    const cartItem = document.querySelector('.cart-item--product-' + upsellHandle);
    
    if (!this.cartItems) {
      return;
    }
    
    if (shouldBeInCart && !cartItem) {
      this.addToCart(upsellElement);
    } else if (!shouldBeInCart && cartItem) {
      this.removeFromCart(upsellElement);
    }
  }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    
    // 初始化DOM元素引用
    this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
    this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells");
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.productID = this.getAttribute("productID")
   
    
    // 初始化配置选项
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.updateUnavailable = this.dataset.updateUnavailable === 'true';
    this.skipNonExistent = this.dataset.skipNonExistent === 'true';
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.updatePdpPrices = this.dataset.updatePdpPrices === "true";
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    
    // 初始化数据存储
    this.selectedVariants = {
      'input_1': [],
      'input_2': [],
      'input_3': [],
      'input_4': [],
      'input_5': [],
      'input_6': []
    };
    this.formVariants = [];
    this.selectedQuantity = 1;
    this.selectedOffer = 1;
    
    // 设置初始选中的数量和offer
    const inputCheckedEl = this.querySelector('input[checked]');
    if (inputCheckedEl) {
      this.selectedQuantity = parseInt(inputCheckedEl.value);
      this.selectedOffer = parseInt(inputCheckedEl.dataset.input.replace("input_", ''));
    }
    
    // 初始化变体选择器
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    
    // 初始化PDP价格更新
    if (this.updatePdpPrices) {
      this.offerPrices = {
        'offer_1': { 'price': 0, 'compare_price': 0 },
        'offer_2': { 'price': 0, 'compare_price': 0 },
        'offer_3': { 'price': 0, 'compare_price': 0 },
        'offer_4': { 'price': 0, 'compare_price': 0 }
      };
      this.initOfferPrices();
    }
    
    // 初始化变体处理
    if (this.hasVariants) {
      this.initVariants();
    }
    
    // 绑定事件监听器
    this.inputs.forEach(input => {
      input.addEventListener("change", this.handleChange.bind(this));
    });
     document.addEventListener(ThemeEvents.variantUpdate, (e) => { 
      this.renderProductInfo(e)
     });
    this.variantSelects.forEach(variant => {
      variant.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  renderProductInfo(e) {
    this.currentVariantId = e.detail.resource.id;
    const sectionId = this.productID;
    const url = this.getAttribute("data-url")
    fetch(url + "?variant=" + this.currentVariantId + "&section_id=" + sectionId)
      .then(response => response.text())
      .then(htmlText => {
        // 确保当前变体没有改变
        if (e.detail.resource.id !== this.currentVariantId) {
          return;
        }
        const parsedHTML = new DOMParser().parseFromString(htmlText, 'text/html');
        // this.updateProductInfoElements(parsedHTML, sectionId);
        this.updateQuantityBreaks(parsedHTML, sectionId);
        // this.updateQuantityBreaksPicker(parsedHTML, sectionId);
        // this.updateSecondarySelect(parsedHTML, sectionId);
      });
  }
   updateQuantityBreaks(parsedHTML,sectionId) {

    // if (!this.QuantityBreaks) return;
    
    const newQuantityBreaks = parsedHTML.getElementById('quantity-breaks-' + sectionId);
    if (!newQuantityBreaks) return;
    
    // 更新动态价格
    const dynamicPriceElements = this.querySelectorAll(".dynamic-price");
    const newDynamicPriceElements = newQuantityBreaks.querySelectorAll(".dynamic-price");
    for (let i = 0; i < dynamicPriceElements.length; i++) {
      if (newDynamicPriceElements[i]) {
        dynamicPriceElements[i].innerHTML = newDynamicPriceElements[i].innerHTML;
      }
    }
    
    // 更新变体选择器
    if (this.hasVariants) {
      this.variantSelects.forEach(select => {
        select.dataset.selectedId = this.currentVariantId;
      });
      
      const variantSelects = this.querySelectorAll(".quantity-break__variant-select");
      const newVariantSelects = newQuantityBreaks.querySelectorAll('.quantity-break__variant-select');
      
      for (let i = 0; i < variantSelects.length; i++) {
        if (newVariantSelects[i]) {
          variantSelects[i].innerHTML = newVariantSelects[i].innerHTML;
        }
      }
      
      this.initVariants();
    }
    
    // 更新选择器图片
    this.querySelectorAll(".quantity-break__selector-item__image img").forEach(img => {
      img.src = this.currentVariant.featured_image.src;
    });
    
    // 更新PDP价格
    if (this.dataset.updatePdpPrices === "true") {
      this.dataset.basePrice = newQuantityBreaks.dataset.basePrice;
      
      this.labels.forEach(label => {
        const newLabel = newQuantityBreaks.querySelector("label[data-input=\"" + label.dataset.input + "\"]");
        if (newLabel) {
          label.dataset.baseComparePrice = newLabel.dataset.baseComparePrice;
        }
      });
      
      this.initOfferPrices();
    }
  }
  initOfferPrices() {
    this.pdpPrices = document.querySelectorAll(".price-" + this.dataset.section);
    const basePrice = parseInt(this.dataset.basePrice);
    
    this.labels.forEach((label, index) => {
      const offerNumber = index + 1;
      const quantity = parseInt(label.dataset.quantity);
      const discountPercentage = parseFloat(label.dataset.percentageLeft);
      const fixedDiscount = parseFloat(label.dataset.fixedDiscount);
      const baseComparePrice = parseInt(label.dataset.baseComparePrice);
      
      // 计算优惠价格
      const discountedPrice = basePrice * quantity * discountPercentage - fixedDiscount;
      const comparePrice = baseComparePrice * quantity;
      
      this.offerPrices["offer_" + offerNumber].price = discountedPrice;
      this.offerPrices['offer_' + offerNumber].compare_price = comparePrice;
    });
    
    this.updateDisplayedPdpPrices();
  }

  updateDisplayedPdpPrices() {
    const currentPrice = this.offerPrices["offer_" + this.selectedOffer].price;
    const formattedPrice = formatMoney(currentPrice, this.moneyFormat);
    const currentComparePrice = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    const formattedComparePrice = formatMoney(currentComparePrice, this.moneyFormat);
    const isOnSale = currentComparePrice > currentPrice;
    
    this.pdpPrices.forEach(priceElement => {
      priceElement.classList.toggle('price--on-sale', isOnSale);
      
      // 更新常规价格
      const regularPriceEl = priceElement.querySelector(".price__regular .price-item--regular");
      if (regularPriceEl) regularPriceEl.innerHTML = formattedPrice;
      
      // 更新销售价格
      const salePriceEl = priceElement.querySelector(".price__sale .price-item--sale");
      if (salePriceEl) salePriceEl.innerHTML = formattedPrice;
      
      if (isOnSale) {
        // 更新原价显示
        const comparePriceEl = priceElement.querySelector(".price__sale .price-item--regular");
        if (comparePriceEl) {
          comparePriceEl.innerHTML = formattedComparePrice;
        }
        
        // 更新节省百分比徽章
        const percentageSavedEl = priceElement.querySelector(".badge__percentage-saved");
        if (percentageSavedEl) {
          const percentageSaved = Math.round((currentComparePrice - currentPrice) * 100 / currentComparePrice);
          percentageSavedEl.innerHTML = percentageSaved;
        }
        
        // 更新节省金额徽章
        const moneySavedEl = priceElement.querySelector(".badge__money-saved");
        if (moneySavedEl) {
          const moneySaved = currentComparePrice - currentPrice;
          const formattedMoneySaved = formatMoney(moneySaved, this.moneyFormat, true);
          moneySavedEl.innerHTML = formattedMoneySaved;
        }
      }
    });
    
    // 更新ATC按钮价格
    const atcPriceElements = document.querySelectorAll('.main-atc-price-span-' + this.dataset.section);
    atcPriceElements.forEach(element => {
      element.innerHTML = formattedPrice;
    });
  }

  handleSelectChange(event) {
    const variantSelector = event.currentTarget;
    const selectedOptions = Array.from(variantSelector.querySelectorAll('select'), select => select.value);
    
    // 更新不可用变体状态
    if (this.updateUnavailable) {
      const availableVariants = this.getVariantData().filter(variant => 
        variantSelector.querySelector(":checked").value === variant.option1
      );
      const selectElements = [...variantSelector.querySelectorAll(".select--small")];
      updateVariantStatuses(availableVariants, selectElements, this.skipUnavailable);
    }
    
    // 查找匹配的变体
    const matchedVariant = this.getVariantData().find(variant => {
      return !variant.options.map((option, index) => {
        return selectedOptions[index] === option;
      }).includes(false);
    });
    
    if (!matchedVariant) {
      if (this.skipNonExistent) {
        findAvailableVariant(variantSelector, selectedOptions, false, true, this.skipUnavailable);
      }
      return;
    }
    
    // 处理不可用变体
    if (this.skipUnavailable && !matchedVariant.available) {
      if (findAvailableVariant(variantSelector, selectedOptions, false, true, true)) {
        return;
      }
    }
    
    // 更新选中的变体ID
    variantSelector.dataset.selectedId = matchedVariant.id;
    const selectIndex = variantSelector.dataset.selectIndex;
    const quantityBreak = variantSelector.closest(".quantity-break");
    const inputName = quantityBreak.dataset.input;
    
    this.selectedVariants[inputName][selectIndex] = matchedVariant.id;
    this.formVariants = this.selectedVariants[inputName];
 
    // 更新媒体显示
    if (!this.preventGalleryScroll) {
      this.updateMedia(matchedVariant);
    }
    
    // 更新变体选择器图片
    const variantImage = variantSelector.querySelector(".quantity-break__selector-item__image img");
    if (variantImage) {
      variantImage.src = matchedVariant.featured_image.src;
    }
    
    if (!this.updatePrices) {
      return;
    }
    
    // 计算价格
    let totalPrice = 0;
    let totalComparePrice = 0;
    const quantity = parseFloat(quantityBreak.dataset.quantity);
    const discountPercentage = parseFloat(quantityBreak.dataset.percentageLeft);
    const fixedDiscount = parseFloat(quantityBreak.dataset.fixedDiscount);
    let useCompareMode = true;
    
    if (quantityBreak.dataset.compareMode === "price") {
      useCompareMode = false;
    }
    
    // 计算所有变体的总价
    for (let i = 0; i < quantity; i++) {
      const variantId = parseInt(this.selectedVariants[inputName][i]);
      const variant = this.getVariantData().find(v => parseInt(v.id) === variantId);
      
      if (!variant) {
        return;
      }
      
      totalPrice += variant.price;
      
      if (variant.compare_at_price && useCompareMode && variant.compare_at_price > variant.price) {
        totalComparePrice += variant.compare_at_price;
      } else {
        totalComparePrice += variant.price;
      }
    }
    
    // 应用折扣
    const discountedPrice = totalPrice * discountPercentage - fixedDiscount;
    const amountSaved = totalComparePrice - discountedPrice;
    const roundedAmountSaved = Math.round(amountSaved / 100) * 100;
    const priceEach = discountedPrice / quantity;
    const comparePriceEach = totalComparePrice / quantity;
    
    // 格式化价格
    const formattedPrice = formatMoney(discountedPrice, this.moneyFormat, true);
    const formattedComparePrice = formatMoney(totalComparePrice, this.moneyFormat, true);
    const formattedAmountSaved = formatMoney(amountSaved, this.moneyFormat, true);
    const formattedRoundedAmountSaved = formatMoney(roundedAmountSaved, this.moneyFormat, true);
    const formattedPriceEach = formatMoney(priceEach, this.moneyFormat, true);
    const formattedComparePriceEach = formatMoney(comparePriceEach, this.moneyFormat, true);
    
    // 更新价格显示
    quantityBreak.querySelectorAll('.variant-price-update').forEach(priceElement => {
      let priceText = priceElement.dataset.text;
      priceText = priceText.replace('[quantity]', quantity);
      priceText = priceText.replace("[price]", formattedPrice);
      priceText = priceText.replace("[compare_price]", formattedComparePrice);
      priceText = priceText.replace("[amount_saved]", formattedAmountSaved);
      priceText = priceText.replace('[amount_saved_rounded]', formattedRoundedAmountSaved);
      priceText = priceText.replace("[price_each]", formattedPriceEach);
      priceText = priceText.replace('[compare_price_each]', formattedComparePriceEach);
      priceElement.innerHTML = priceText;
    });
    
    // 更新比较价格显示
    const comparePriceElement = quantityBreak.querySelector('.quantity-break__compare-price');
    if (comparePriceElement) {
      if (totalComparePrice > discountedPrice) {
        comparePriceElement.classList.remove("hidden");
      } else {
        comparePriceElement.classList.add('hidden');
      }
    }
    
    // 更新PDP价格
    if (this.updatePdpPrices) {
      this.offerPrices['offer_' + this.selectedQuantity].price = discountedPrice;
      this.offerPrices["offer_" + this.selectedQuantity].compare_price = totalComparePrice;
      this.updateDisplayedPdpPrices();
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }

  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    
    this.labels.forEach(label => {
      if (label.querySelector(".quantity-break__variants")) {
        let selectedIds = [];
        label.querySelectorAll(".quantity-break__selector-item").forEach(selector => {
          selectedIds.push(selector.dataset.selectedId);
        });
        this.selectedVariants[label.dataset.input] = selectedIds;
      }
    });
    
    this.formVariants = [];

  }

  updateMedia(variant) {
    if (!variant || !variant.featured_media) {
      return;
    }
    
    const mediaGalleries = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    mediaGalleries.forEach(gallery => {
      gallery.setActiveMedia(this.dataset.section + '-' + variant.featured_media.id, true);
    });
  }

  handleChange(event) {
    const selectedQuantity = parseInt(event.target.value);
    this.selectedQuantity = selectedQuantity;
    this.selectedOffer = parseInt(event.target.dataset.input.replace("input_", ''));
    
    // 更新选中的变体
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[event.target.dataset.input];
    }
    
    // 解锁礼物
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(selectedQuantity);
    }
    
    // 初始化upsell解锁
    this.quantityBreakUpsells.forEach(upsell => {
      upsell.initUnlock();
    });
    
    // 更新PDP价格显示
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector('.internal-video__play');
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector('video');
    
    // Remove invalid video source format if present
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    
    // Event listeners setup
    if (this.playButton) {
      this.playButton.addEventListener('click', this.playVideo.bind(this));
    }
    
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    
    if (this.video) {
      this.video.addEventListener('ended', this.endedVideo.bind(this));
    }
    
    if (this.timeline) {
      this.video.addEventListener('timeupdate', this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener('mousedown', this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener('mousemove', this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    
    // Autoplay when in viewport
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
      this.observer.observe(this);
    }
  }
  
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      
      this.classList.add("internal-video--playing");
      
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      
      const playPromise = this.video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(() => {
          this.classList.add('internal-video--playing');
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "hidden";
          }
        }).catch(error => {
          this.classList.remove("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = 'visible';
          }
        });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  
  endedVideo() {
    this.classList.remove('internal-video--playing');
  }
  
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  
  updateTimeline() {
    const percentComplete = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty('--completed', percentComplete + '%');
  }
  
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  
  startDrag(event) {
    event.preventDefault();
    this.dragging = true;
    this.drag(event);
  }
  
  stopDrag() {
    this.dragging = false;
  }
  
  drag(event) {
    if (!this.dragging) return;
    
    if (event.touches) {
      event = event.touches[0];
    }
    
    this.seekVideo(event);
  }
  
  seekVideo(event) {
    const timelineRect = this.timeline.getBoundingClientRect();
    const clickPosition = event.clientX - timelineRect.left;
    const percent = clickPosition / timelineRect.width;
    this.video.currentTime = percent * this.video.duration;
  }
  
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Load all data-src sources
        for (let source of this.video.querySelectorAll("source[data-src]")) {
          source.setAttribute("src", source.getAttribute('data-src'));
          source.removeAttribute("data-src");
        }
        
        this.video.load();
        const playPromise = this.video.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            if (error.name === 'NotAllowedError') {
              this.classList.remove('internal-video--playing');
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = "visible";
              }
            }
          }).then(() => {
            this.video.play();
          });
        }
        
        this.observer.disconnect();
      }
    });
  }
}

// Define the custom element
customElements.define("internal-video", InternalVideo)

class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(','));
    this.months = this.dataset.monthLabels.split(',');
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.insertDates();
    
    // This function is presumably defined elsewhere
    checkDateValidity(currentDate);
    
    document.addEventListener("shopify:section:load", event => {
      this.insertDates();
    });
  }
  
  insertDates() {
    this.elementsToChange.forEach(element => {
      const textTemplate = element.dataset.text;
      const minDays = parseInt(element.dataset.minDays);
      const maxDays = parseInt(element.dataset.maxDays);
      
      const startDate = addDays(currentDate, minDays);
      let startSuffix = 'th';
      const startDay = startDate.getDate();
      
      if (startDay === 1 || startDay === 21 || startDay === 31) {
        startSuffix = 'st';
      } else if (startDay === 2 || startDay === 22) {
        startSuffix = 'nd';
      } else if (startDay === 3 || startDay === 23) {
        startSuffix = 'rd';
      }
      
      const endDate = addDays(currentDate, maxDays);
      let endSuffix = 'th';
      const endDay = endDate.getDate();
      
      if (endDay === 1 || endDay === 21 || endDay === 31) {
        endSuffix = 'st';
      } else if (endDay === 2 || endDay === 22) {
        endSuffix = 'nd';
      } else if (endDay === 3 || endDay === 23) {
        endSuffix = 'rd';
      }
      
      let formattedStartDate;
      let formattedEndDate;
      
      switch (this.dateFormat) {
        case "day_dd_mm":
          formattedStartDate = `${this.days[startDate.getDay()]}, ${startDate.getDate()}. ${this.months[startDate.getMonth()]}`;
          formattedEndDate = `${this.days[endDate.getDay()]}, ${endDate.getDate()}. ${this.months[endDate.getMonth()]}`;
          break;
          
        case "mm_dd":
          formattedStartDate = `${this.months[startDate.getMonth()]} ${startDate.getDate()}${startSuffix}`;
          formattedEndDate = `${this.months[endDate.getMonth()]} ${endDate.getDate()}${endSuffix}`;
          break;
          
        case "dd_mm":
          formattedStartDate = `${startDate.getDate()}. ${this.months[startDate.getMonth()]}`;
          formattedEndDate = `${endDate.getDate()}. ${this.months[endDate.getMonth()]}`;
          break;
          
        case "dd_mm_no_dot":
          formattedStartDate = `${startDate.getDate()} ${this.months[startDate.getMonth()]}`;
          formattedEndDate = `${endDate.getDate()} ${this.months[endDate.getMonth()]}`;
          break;
          
        case "day_dd_mm_numeric":
          const startDayFormatted = String(startDate.getDate()).length > 1 ? startDate.getDate() : '0' + startDate.getDate();
          const startMonthFormatted = String(startDate.getMonth() + 1).length > 1 ? startDate.getMonth() + 1 : '0' + (startDate.getMonth() + 1);
          formattedStartDate = `${this.days[startDate.getDay()]}, ${startDayFormatted}. ${startMonthFormatted}.`;
          
          const endDayFormatted = String(endDate.getDate()).length > 1 ? endDate.getDate() : '0' + endDate.getDate();
          const endMonthFormatted = String(endDate.getMonth() + 1).length > 1 ? endDate.getMonth() + 1 : '0' + (endDate.getMonth() + 1);
          formattedEndDate = `${this.days[endDate.getDay()]}, ${endDayFormatted}. ${endMonthFormatted}.`;
          break;
          
        case "dd_mm_numeric":
          const startDayNum = String(startDate.getDate()).length > 1 ? startDate.getDate() : '0' + startDate.getDate();
          const startMonthNum = String(startDate.getMonth() + 1).length > 1 ? startDate.getMonth() + 1 : '0' + (startDate.getMonth() + 1);
          formattedStartDate = `${startDayNum}. ${startMonthNum}.`;
          
          const endDayNum = String(endDate.getDate()).length > 1 ? endDate.getDate() : '0' + endDate.getDate();
          const endMonthNum = String(endDate.getMonth() + 1).length > 1 ? endDate.getMonth() + 1 : '0' + (endDate.getMonth() + 1);
          formattedEndDate = `${endDayNum}. ${endMonthNum}.`;
          break;
          
        default:
          formattedStartDate = `${this.days[startDate.getDay()]}, ${this.months[startDate.getMonth()]} ${startDate.getDate()}${startSuffix}`;
          formattedEndDate = `${this.days[endDate.getDay()]}, ${this.months[endDate.getMonth()]} ${endDate.getDate()}${endSuffix}`;
      }
      
      const textWithStartDate = textTemplate.replace('[start_date]', formattedStartDate);
      const finalText = textWithStartDate.replace("[end_date]", formattedEndDate);
      element.innerHTML = finalText;
    });
  }
  
  rearrangeDays(daysArray) {
    // Move Sunday to the beginning of the week
    daysArray.unshift(daysArray[6]);
    daysArray.length = 7;
    return daysArray;
  }
}

// Define the custom element
customElements.define('dynamic-dates', DynamicDates)
class DateCountdownTimer extends HTMLElement {
  connectedCallback() {
    if ((this.update = this.update.bind(this)), !(this.wrapper = this.closest(".countdown-wrapper"))) return;

    let endTime = this.wrapper.dataset.endTime;
    let timezone = this.wrapper.dataset.timezone;
    let utcOffset = parseInt(this.wrapper.dataset.utcOffset) || 0;

    this.behavior = this.wrapper.dataset.endBehavior;
    this.repeatHours = parseInt(this.wrapper.dataset.repeatHours) || 24;
    this.labels = {
      days: this.wrapper.dataset.labelDays,
      hours: this.wrapper.dataset.labelHours,
      minutes: this.wrapper.dataset.labelMinutes,
      seconds: this.wrapper.dataset.labelSeconds
    };

    this.units = {
      days: "true" === this.wrapper.dataset.showDays,
      hours: "true" === this.wrapper.dataset.showHours,
      minutes: "true" === this.wrapper.dataset.showMinutes,
      seconds: "true" === this.wrapper.dataset.showSeconds
    };

    this.showColons = "true" === this.wrapper.dataset.colons;
    this.timerStyle = this.dataset.style;

    let date;
    if ("fixed" === timezone) {
      date = new Date(endTime + "Z");
      this.endTime = new Date(date.getTime() - 3600000 * utcOffset);
    } else {
      date = new Date(endTime);
      this.endTime = date;
    }

    this.timer = setInterval(this.update, 1000);
    this.update();
  }

  update() {
    let currentTime = new Date();
    let secondsRemaining = Math.floor((this.endTime - currentTime) / 1000);

    if (secondsRemaining <= 0) {
      if ("hide" === this.behavior) {
        this.wrapper.style.display = "none";
        clearInterval(this.timer);
        return;
      }

      if ("restart" === this.behavior) {
        let restartTime = new Date(this.endTime);
        let repeatMilliseconds = 3600000 * this.repeatHours;

        while (restartTime <= currentTime) {
          restartTime = new Date(restartTime.getTime() + repeatMilliseconds);
        }

        this.endTime = restartTime;
        secondsRemaining = Math.floor((this.endTime - currentTime) / 1000);
      } else if ("next_day" === this.behavior) {
        let nextDayTime = new Date(this.endTime);

        while (nextDayTime <= currentTime) {
          nextDayTime.setDate(nextDayTime.getDate() + 1);
        }

        this.endTime = nextDayTime;
        secondsRemaining = Math.floor((this.endTime - currentTime) / 1000);
      }
    }

    let days = Math.floor(secondsRemaining / 86400);
    let hours = Math.floor(secondsRemaining % 86400 / 3600);
    let minutes = Math.floor(secondsRemaining % 3600 / 60);
    let seconds = secondsRemaining % 60;

    let displayData = [];
    this.units.days && displayData.push({ label: this.labels.days, value: days });
    this.units.hours && displayData.push({ label: this.labels.hours, value: hours });
    this.units.minutes && displayData.push({ label: this.labels.minutes, value: minutes });
    this.units.seconds && displayData.push({ label: this.labels.seconds, value: seconds });

    this.innerHTML = "";
    displayData.forEach((unit, index) => {
      let block = document.createElement("div");
      block.className = "countdown-timer__block";

      let numberElement = document.createElement("div");
      numberElement.className = "countdown-timer__number";

      let formattedValue = String(unit.value).padStart(2, "0");

      if ("4" === this.timerStyle) {
        let digits = formattedValue.split("");
        digits.forEach(digit => {
          let digitElement = document.createElement("span");
          digitElement.className = "countdown-timer__digit";
          digitElement.textContent = digit;
          numberElement.appendChild(digitElement);
        });
      } else {
        numberElement.textContent = formattedValue;
      }

      block.appendChild(numberElement);

      if (unit.label.length) {
        let labelElement = document.createElement("span");
        labelElement.className = "countdown-timer__label";
        labelElement.textContent = unit.label;
        block.appendChild(labelElement);
      }

      if (this.showColons && index > 0) {
        let colon = document.createElement("span");
        colon.className = "countdown-timer__colon";
        colon.textContent = ":";
        this.appendChild(colon);
      }

      this.appendChild(block);
    });
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
}

customElements.define("date-countdown-timer", DateCountdownTimer);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.duration = parseInt(this.dataset.duration);
    this.initTimer();
    this.updateTimer();
    
    if (this.dataset.autoPlay === "true") {
      this.playTimer();
    }
  }
  
  initTimer() {
    this.innerHTML = "";
    
    this.minutesSpan = document.createElement("span");
    const colon = document.createTextNode(":");
    this.secondsSpan = document.createElement("span");
    
    this.append(this.minutesSpan, colon, this.secondsSpan);
  }
  
  updateTimer() {
    let timeRemaining = parseInt(this.dataset.duration);
    
    if (timeRemaining === 0) {
      timeRemaining = 90;
    }
    
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    this.minutesSpan.innerHTML = this.formatNumber(minutes);
    this.secondsSpan.innerHTML = this.formatNumber(seconds);
    this.dataset.duration = timeRemaining - 1;
  }
  
  playTimer() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      
      this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1000);
    }
  }
  
  pauseTimer() {
    clearTimeout(this.playInterval);
    this.isPlaying = false;
  }
  
  formatNumber(number) {
    return number.toString().length === 1 
      ? "0" + number 
      : number;
  }
}

// Define the custom element
customElements.define("countdown-timer", CountdownTimer)

// 自定义购买按钮
customElements.define("checkout-button", class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleCheckout.bind(this));
  }
  handleCheckout() {
    this.quantityBreak = document.querySelector("quantity-breaks");
    const id = this.getAttribute("product-id");
    const form = Array.from(document.querySelector(`#${id}`));
    let checkoutStr = `/cart/`

    if(this.quantityBreak &&this.quantityBreak.formVariants != 0){
      this.quantityBreak.formVariants.forEach((id, index) => {
        checkoutStr += `${id}:1,`
      })
    }else{
      form.forEach((i, idx) => {
        if (i.name === "id") {
          checkoutStr += `${i.value}:1,`
        }
      })
    }

    window.location.href = checkoutStr
  }
})

// 尺码功能
class sizingChart extends Component{
  requiredRefs
  connectedCallback(){
    super.connectedCallback();
    this.onSwitchImage();
  }
  onSwitchImage(){
    const that = this
    this.querySelector("ul").addEventListener("click",function(e){
      that.querySelectorAll(".sizing_image").forEach(i=>{
        if(i.classList.contains("active")){
          i.classList.remove("active")
        }else{
          i.classList.add("active")
        }
      })
      that.querySelectorAll("ul li").forEach(i=>{
        if(i.classList.contains("active")){
          i.classList.remove("active")
        }else{
          i.classList.add("active")
        }
      })
    })
  }
}

customElements.define("sizing-chart", sizingChart)

document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get('swiper-component')) {
    customElements.define(
      'swiper-component',
      class extends HTMLElement {
        constructor() {
          super();
          const desktopSize = this.getAttribute('data-desktop');
          const mobileSize = this.getAttribute('data-mobile');
          const showNavigation = this.getAttribute('data-navigation');
          const showPagination = this.getAttribute("data-pagination");
          const centeredSlides = this.getAttribute("data-centeredSlides")
          const slidesPerGroup = this.getAttribute("data-groupSize")
          const nextEl = this.querySelector(".swiper-button-next");
          const prevEl = this.querySelector(".swiper-button-prev");
          const paginationEl = this.querySelector(".swiper-pagination")
          const config = {

            breakpoints: {
              320: {
                //当屏幕宽度大于等于320
                slidesPerView: mobileSize,
                spaceBetween: 10,
              },
              768: {
                //当屏幕宽度大于等于768
                slidesPerView: desktopSize,
                spaceBetween: 20,
              },
            },
          }
          if (showNavigation) {
            config.navigation = {
              nextEl,
              prevEl
            }
          }
          if (showPagination) {
            config.pagination = {
              el: paginationEl,
            }
          }
          new Swiper(this.querySelector('.swiper'), config);
        }
      }
    );
  }
})